import { MessageCircle } from "lucide-react";
import useSiteConfig, { whatsappLinkFromCfg } from "@/lib/useSiteConfig";

/**
 * Floating WhatsApp CTA shown across the site. Clean pill, right-bottom, brand-tuned.
 * Reads the phone number from /api/site-config so admins can rotate without redeploy.
 */
export default function WhatsAppFab() {
  const cfg = useSiteConfig();
  return (
    <a
      href={whatsappLinkFromCfg(cfg)}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-5 right-5 z-40 hidden items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-medium text-white shadow-soft transition-transform hover:-translate-y-0.5 md:inline-flex"
    >
      <MessageCircle size={18} /> Talk to us
    </a>
  );
}
